<template>
  <div class="content-view">
    <div class="top-box">
      <div class="people-info">个人信息</div>
      <div class="bottom-box">
        <el-card>
          <div class="box-card">
            <img
              src="../../../assets/image/default.png"
              style="width: 100px; height: 100px"
            />
            <div style="margin-left: 80px">
              <div class="name-txt">{{ user.nickName }}</div>
              <div class="flex card-item">
                <div class="card-item-txt">手机号</div>
                <div class="card-item-content">{{ user.phonenumber }}</div>
              </div>
              <div class="flex card-item">
                <div class="card-item-txt">邮 箱</div>
                <div class="card-item-content">{{ user.email }}</div>
              </div>
            </div>
            <div class="btn-box">
              <el-button round @click="updateInfo">修改个人信息</el-button>
              <el-button round @click="updatePsw">修改密码</el-button>
            </div>
          </div>
        </el-card>
        <div class="com-box">
          <div class="com-info-txt">企业信息</div>
          <div class="flex com-item">
            <div class="item_txt">企业账号</div>
            <div class="item-content">{{ user.userName }}</div>
          </div>
          <div class="flex com-item">
            <div class="item_txt">所属部门</div>
            <div class="item-content">{{ deptName }}{{ postGroup }}</div>
          </div>
          <div class="flex com-item">
            <div class="item_txt">所属角色</div>
            <div class="item-content">{{ roleGroup }}</div>
          </div>
          <div class="flex com-item">
            <div class="item_txt">创建日期</div>
            <div class="item-content">{{ user.createTime }}</div>
          </div>
        </div>
      </div>
      <div class="img"></div>
      <div style="background-color: #fff; height: 620px"></div>
      <!-- <img class="img" src="../../../assets/image/phy-down-limit.png" > -->
    </div>
  </div>
</template>
<script>
import { getUserProfile } from "@/api/system/user";
export default {
  components: {},
  // 定义属性
  data() {
    return {
      user: {},
      roleGroup: {},
      postGroup: {},
      deptName: "",
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {
    "user.dept": {
      handler: function (val, oldVal) {
        if (val) {
          this.deptName = val.deptName + "/";
        } else {
          this.deptName = "";
        }
      },
      deep: true,
    },
  },
  // 方法集合
  methods: {
    updateInfo() {
      this.$router.push({
        name: "updateInfo",
        query: {
          nickName: this.user.nickName,
          phonenumber: this.user.phonenumber,
          email: this.user.email,
        },
      });
    },
    updatePsw() {
      this.$router.push({
        name: "updatePsw",
      });
    },
    getUser() {
      getUserProfile().then((response) => {
        this.user = response.data;
        this.roleGroup = response.roleGroup;
        this.postGroup = response.postGroup;
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getUser();
    localStorage.setItem("keyword", "");
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='scss' scoped>
.people-info {
  position: absolute;
  margin: 30px;
  color: white;
}
.img {
  width: 100%;
  height: 210px;
  background-image: url("../../../assets/image/usercenter-bg.png");
  background-position: top right;
}
.bottom-box {
  position: absolute;
  width: calc(100% - 240px);
  margin: 100px 100px 0px 100px;
}
.box-card {
  display: flex;
  padding: 30px 50px 20px 50px;
}

.flex {
  display: flex;
}

.name-txt {
  text-align: left;
  font-weight: bold;
  font-size: 20px;
  color: #333;
}
.card-item {
  margin-top: 40px;
}
.item_txt {
  font-size: 18px;
  color: #666;
}
.card-item-txt {
  width: 55px;
  text-align: left;
  font-size: 18px;
  color: #666;
}
.btn-box {
  position: absolute;
  right: 30px;
  top: 175px;
}
.btn-box .el-button.is-round {
  color: #1a8bbc;
  border: 1px solid #1a8bbc;
}
.com-box {
  background-color: white;
  margin-top: 40px;
}
.com-info-txt {
  background-color: #eeeeee;
  text-align: left;
  color: #333;
  font-size: 18px;
  padding: 20px 70px;
}
.com-item {
  margin: 50px 0 0 70px;
}
.item-content {
  color: #333;
  font-size: 18px;
  margin-left: 60px;
}
.card-item-content {
  color: #333;
  font-size: 18px;
  margin-left: 40px;
}
</style>
